import React from 'react';
import ReactDOM from 'react-dom';

import 'assets/css/bootstrap.min.css';
import 'assets/scss/paper-kit.scss';
import 'assets/demo/demo.css';
import 'assets/demo/react-demo.css';
import ProfilePage from 'ProfilePage.js';

ReactDOM.render(<ProfilePage />, document.getElementById('root'));
